module.exports = {"ADM_DASHBOARD_MAIN_TITLE":"Company","ADM_DASHBOARD_SALES_TITLE":"Sales","ADM_DASHBOARD_ACQUISITION_TITLE":"Acquisition and Retention"}